import { createQueryKeys } from '@lukemorales/query-key-factory'

import { CurrentOrganizationUser,  } from '@organization/api/requests'
import { getUrlSubDomain } from '@organization/utils'

import { mainAxios } from './axios/mainAxios'

const hostName = getUrlSubDomain

export const users = {
  get: async () => {
    const { data } = await mainAxios.post<CurrentOrganizationUser>(
      '/users/login/user/',
      {
        domain_name: hostName
      }
    )

    return data
  },
}

export const usersQuery = createQueryKeys('users', {
  get: () => ({
    queryKey: ['profile'],
    queryFn: () => users.get()
  })
})
